import styled from 'styled-components';

import LegacyTextField from 'src/components/LegacyTextField/TextField';

export const TextField = styled(LegacyTextField)`
  input {
    background-image: linear-gradient(to left, #91b6ca40, #ebf5fa 20%);
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 8px;
    border: unset;
    font-size: 14px;
    :focus {
      border: unset;
    }
    :hover {
      border: unset;
    }
  }
`;
